import React from "react";
import classes from "./ServicesComponents.module.scss";

const IssuingMode = ({ onChangeMode, currentMode, errorMsg }) => {
  return (
    <div>
      {currentMode === "TEST" && (
        <>
          <p>
            In order to start issuing invoicing for this company, you need to
            switch issuing to production mode.
          </p>
          <button
            className={`${classes.refreshBtn} px-3`}
            onClick={() => onChangeMode("IEI")}
          >
            Switch issuing to production
          </button>
        </>
      )}
      {currentMode === "PROD" && (
        <p>
          The issuing of invoices for this company has been set to
          production mode.
        </p>
      )}
      {currentMode === "error" && <p>{errorMsg}</p>}
    </div>
  );
};

export default IssuingMode;
